export declare type FreightClass =
  | '50'
  | '55'
  | '60'
  | '65'
  | '70'
  | '77.5'
  | '85'
  | '92.5'
  | '100'
  | '110'
  | '125'
  | '150'
  | '175'
  | '200'
  | '250'
  | '300'
  | '400'
  | '500'

export const freightClassesMap = new Map<FreightClass, string>([
  ['50', '50'] as const,
  ['55', '55'] as const,
  ['60', '60'] as const,
  ['65', '65'] as const,
  ['70', '70'] as const,
  ['77.5', '77.5'] as const,
  ['85', '85'] as const,
  ['92.5', '92.5'] as const,
  ['100', '100'] as const,
  ['110', '110'] as const,
  ['125', '125'] as const,
  ['150', '150'] as const,
  ['175', '175'] as const,
  ['200', '200'] as const,
  ['250', '250'] as const,
  ['300', '300'] as const,
  ['400', '400'] as const,
  ['500', '500'] as const,
])
